import { Button } from "@material-ui/core";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import React from "react";
import StatusCellRenderer from "./StatusCellRenderer";

type Props = {
	onSend: (data: any) => void;
};
export const useTableData = ({ onSend }: Props) => {
	const columns: ColDef[] = [
		{
			field: "Heat",
			headerName: "Heat",
			flex: 1,
			minWidth: 65,
		},
		{
			field: "Sample",
			headerName: "Sample",
			flex: 1,
			minWidth: 69,
		},
		{
			field: "Grade",
			headerName: "Grade",
			flex: 1,
			minWidth: 80,
			wrapText: true,
		},
		{
			field: "LabDateTime",
			headerName: "Date",
			flex: 1,
			minWidth: 136,
		},
		{
			field: "Technician",
			headerName: "Technician",
			flex: 1,
			minWidth: 89,
		},
		{
			field: "ChecksPassed",
			headerName: "Check",
			flex: 1,
			minWidth: 62,
			maxWidth: 62,
			cellRenderer: StatusCellRenderer,
			cellRendererParams: {
				type: "check",
			},
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "ChecksResults",
			headerName: "Results",
			flex: 4,
			minWidth: 250,
			wrapText: true,
		},
		{
			field: "Sent",
			headerName: "Sent",
			flex: 1,
			minWidth: 62,
			maxWidth: 62,
			cellRenderer: StatusCellRenderer,
			cellRendererParams: {
				type: "sent",
			},
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "Ack",
			headerName: "Ack by L3",
			flex: 1,
			minWidth: 90,
			wrapHeaderText: true,
			valueGetter: (params) => (params.data.Ack === 1 ? true : false),
			cellRenderer: StatusCellRenderer,
			cellRendererParams: {
				type: "ack",
			},
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "Name",
			headerName: "Force",
			type: ["nonSorteable", "nonFilterable"],
			flex: 1,
			minWidth: 90,
			cellRenderer: (params: ICellRendererParams) => {
				return (
					<Button
						variant="contained"
						color="primary"
						size="small"
						style={{ minWidth: "60px" }}
						onClick={() => onSend(params.data)}
						disabled={params.data?.Sent}
					>
						SEND
					</Button>
				);
			},
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "SentBy",
			headerName: "Sent by",
			flex: 1,
			minWidth: 80,
		},
	];

	return { columns };
};
